import type { MouseEvent } from 'react';
import { memo, useCallback, useContext } from 'react';
import styled from '@emotion/styled';
import { StyledSup } from './MarkdownElements';
import { useHover } from '@trinity/chat-components/hooks/useHover';
import { ClickCitationContext } from '@trinity/chat-components/components/Chat/context';


type CitationProps = {
  value: string;
  style?: React.CSSProperties;
};

export const Citation = memo(({ style = {}, value }: CitationProps) => {
  const onCitationClick = useContext(ClickCitationContext);
  const onClick = useCallback((e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onCitationClick(value);
  }, [onCitationClick, value]);

  return (
    <StyledSup
      onClick={onClick}
      style={style}>
      {value}
    </StyledSup>
  );
});

type CitationsProps = {
  values: string[];
};

export const Citations = memo(({ values }: CitationsProps) => {

  const [ref, hovering] = useHover();

  return (
    <CitationsRoot ref={ref}>
      {hovering && (
        <div>
          {values.map((value, index) => (
            <Citation key={index} value={value} />
          ))}
        </div>
      )}
      {!hovering && (
        <div>
          <StyledSup>
            {values.length} Citations
          </StyledSup>
        </div>
      )}
    </CitationsRoot>
  );
});

const CitationsRoot = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
});